<template>
  <div class="main">
    <img class="img" src="../assets/images/error-page.png" alt="unlucky" />
    <div class="text"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    width: 360px;
    height: 262px;
    margin-bottom: 70px;
  }

  .text {
    font-size: 30px;
    color: #8c8c8c;
  }
}
</style>
